import * as React from "react";

const BancIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="23.071"
    height="23.038"
    viewBox="0 0 23.071 23.038"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x2="1"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#02a"></stop>
        <stop offset="1" stopColor="#1a64b9"></stop>
      </linearGradient>
    </defs>
    <path
      id="bank"
      fill="url(#linear-gradient)"
      stroke="rgba(0,0,0,0)"
      strokeWidth="1"
      d="M22 21.082a.917.917 0 0 1-.917.917H.916a.917.917 0 0 1 0-1.833h20.165a.917.917 0 0 1 .919.916ZM.267 7.839a2.24 2.24 0 0 1 .14-2.352 4.3 4.3 0 0 1 1.529-1.375L8.811.533a4.74 4.74 0 0 1 4.376 0l6.874 3.581a4.3 4.3 0 0 1 1.529 1.375 2.24 2.24 0 0 1 .14 2.352 2.49 2.49 0 0 1-2.214 1.324h-.268V16.5h.917a.917.917 0 0 1 0 1.833H1.833a.917.917 0 0 1 0-1.833h.917V9.166h-.268A2.49 2.49 0 0 1 .267 7.839ZM4.583 16.5h2.75V9.166h-2.75Zm4.583-7.334V16.5h3.666V9.166Zm8.249 0h-2.75V16.5h2.75ZM1.891 6.989a.66.66 0 0 0 .591.344h17.034a.66.66 0 0 0 .591-.344.41.41 0 0 0-.022-.458 2.5 2.5 0 0 0-.87-.792l-6.874-3.581a2.91 2.91 0 0 0-2.682 0L2.784 5.739a2.5 2.5 0 0 0-.87.793.41.41 0 0 0-.024.457Z"
      transform="translate(.537 .539)"
    ></path>
  </svg>
);

export default BancIcon;
